export default "__VITE_ASSET__9a_Sll0J3_WTqljGgO8_pQ__"